// extracted by mini-css-extract-plugin
export default {"animatedSvg":"nxDMr7"};